<template>
  <div>
    <el-dialog
        :title="$t('posts.dialog.deleteTitle')"
        :visible.sync="modalDelete"
        @close="$emit('close-modal-delete')"
        width="30%"
    >
      <span v-if="isModel">{{ $t("posts.dialog.modelDeleteText") }}</span>
      <span v-else-if="showSoldProductsDeleteOption">{{ $t("posts.dialog.deleteTextSoldProductOption") }}</span>
      <span v-else>{{ $t("posts.dialog.deleteText") }}</span>
<!--      <span>{{ $t("posts.dialog.deleteText") }}</span>-->

      <span slot="footer" class="dialog-footer" v-if="isModel">
                <el-button @click="SET_MODAL_DELETE(false)">{{ $t("posts.dialog.cancel") }}</el-button>
                <el-button type="danger" @click="$emit('delete-post')"> {{ $t("posts.list.delete") }}</el-button>
            </span>

      <span slot="footer" class="dialog-footer" v-else-if="showSoldProductsDeleteOption">
                <el-button @click="SET_MODAL_DELETE(false)">Annuler</el-button>
                <el-button type="danger"
                           @click="$emit('delete-post')"> {{ $t("posts.list.declarePostAsDeleteByNo") }}</el-button>
                <el-button type="success"
                           @click="$emit('sold-post')"> {{ $t("posts.list.declarePostAsSoldByYes") }}</el-button>
            </span>

      <span slot="footer" class="dialog-footer" v-else>
                <el-button @click="SET_MODAL_DELETE(false)">Annuler</el-button>
                <el-button type="danger" @click="$emit('delete-post')"> {{ $t("posts.list.delete") }}</el-button>
      </span>

    </el-dialog>
  </div>

</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import ElButton from '../../../../components/Button'

export default {
  name: 'DialogDeletePost',
  components: {
    ElButton
  },
  data () {
    return {
      referenceDuplication: null
    }
  },
  computed: {
    ...mapGetters([
      'hasMultiAccounts',
      'isMainAccount',
      'isSubAdmin',
      'isSubUser',
      'getOfferTypes',
      'getPickerOptionsShortcuts',
      'isSoldProductsOption'
    ]),
    ...mapGetters('dialogsPostsListImmo', ['postToDelete', 'postStateToDelete']),
    ...mapGetters('postsListImmo', ['list']),
    // get/set pour :visible.sync (fermeture via la croix)
    modalDelete: {
      get () {
        return this.$store.getters['dialogsPostsListImmo/modalDelete']
      },
      set (value) {
        this.SET_MODAL_DELETE(value)
      }
    },
    isModel () {
      return this.postStateToDelete === 'M'
    },
    // BV limité aux ventes (#103737) — aligné CardFooterImmo (typeOffre !== 'L')
    showSoldProductsDeleteOption () {
      const post = (this.list || []).find(p => p.id === this.postToDelete)
      return this.isSoldProductsOption && (!post || post.typeOffre !== 'L')
    },
    userFilter () {
      return this.filter.user
    }
  },
  methods: {
    ...mapMutations('dialogsPostsListImmo', ['SET_MODAL_DELETE'])
    // ...mapMutations('postsListImmo', ['DELETE_POSTS']))
  }
}

</script>
